<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western" id="calibre_pb_6">
<p class="western2"> <br class="calibre2"/></p>
<p class="western11"> <br class="calibre2"/></p>
<p class="western12">This is for everyone who wanted to know what
happened to John.</p>
</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_81917b76c0dc0690a3d5075948c70f3d_BuZtIk.ch.fixed.fc.tidied.stylehacked.xfixed_split_006.vue?5dca0241